var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spaceCenter" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "exchange-card",
      },
      [
        _c(
          "div",
          { staticClass: "exchange-tab-box" },
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.changeTab },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c("el-tab-pane", { attrs: { name: "Deposit" } }, [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("i", { staticClass: "iconfont trn-deposits" }),
                    _vm._v(" Deposit"),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-tab-pane", { attrs: { name: "Withdraw" } }, [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("i", { staticClass: "iconfont trn-withdraw" }),
                    _vm._v(" Withdraw"),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "exchange-tab-body" },
          [
            _c("div", { staticClass: "deposite-balance" }, [
              _vm._v("\n        Deposits:\n        "),
              _c(
                "span",
                { staticClass: "deposite-balance-num" },
                [
                  _c("big-number", {
                    attrs: { number: _vm.depositeBalance },
                    on: {
                      "update:number": function ($event) {
                        _vm.depositeBalance = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "word-sm" }, [_vm._v("TCash")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "spaceBetween" }, [
              _c("span", { staticClass: "word-sm" }, [
                _c("img", {
                  staticStyle: { width: "0.16rem" },
                  attrs: {
                    src: require("@/assets/image/exchange/jiantou2.svg"),
                  },
                }),
                _vm._v(
                  "\n          1 TCash = $ " + _vm._s(_vm.price) + "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "word-sm",
                  staticStyle: { color: "rgb(220, 224, 231)" },
                },
                [
                  _vm._v("\n          Balance : "),
                  _c("big-number", {
                    attrs: { number: _vm.balance },
                    on: {
                      "update:number": function ($event) {
                        _vm.balance = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "spaceBetween exchange-item" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-input", {
                    staticClass: "exchange-input",
                    attrs: { placeholder: "0.00" },
                    on: { change: _vm.exchangeInput },
                    model: {
                      value: _vm.exchangeNum,
                      callback: function ($$v) {
                        _vm.exchangeNum = $$v
                      },
                      expression: "exchangeNum",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-right word-sm-num" }, [
                    _vm._v("$ " + _vm._s(_vm.changeMoney)),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("checkLoginBtn", { on: { clickHandle: _vm.submit } }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spaceLeft" }, [
      _c("img", {
        staticStyle: { width: "0.44rem", "margin-right": "0.16rem" },
        attrs: { src: require("@/assets/image/exchange/ustn.png") },
      }),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "word-sm-black" }, [_vm._v("TCash")]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "word-sm",
            staticStyle: { color: "rgb(86, 98, 122)" },
          },
          [_vm._v("Deposit")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "word-sm",
        staticStyle: {
          "margin-top": "0.88rem",
          "line-height": "0.32rem",
          "margin-bottom": "0.2rem",
        },
      },
      [
        _vm._v("\n        Deposit rules :"),
        _c("br"),
        _vm._v(
          "\n        1. The deposit amount must be greater than or equal to 10^-9 TCash"
        ),
        _c("br"),
        _vm._v(
          "\n        2. Deposit interest will be calculated from the second day of deposit\n      "
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }